import { LastTransactionModel } from 'api-hooks/guest';
import { capitalize } from 'common/utils/string';
import Separator from 'components/common/separator';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import Text from 'components/elements/text';
import useDate from 'hooks/use-date';
import { CardContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  data: LastTransactionModel[];
  isLoading: boolean;
}

export default function LastTransactionTable(props: Props) {
  const { t } = useTranslation();
  const { data, isLoading } = props;
  const formatDate = useDate();

  const columns = React.useMemo<IColumn<LastTransactionModel>[]>(
    () => [
      {
        header: t('common:invoice_date'),
        accessorKey: 'invoiceDate',
        minSize: 100,
        maxSize: 100,
        cell: ({ getValue }) => {
          const date = getValue() as Date;
          return date ? (
            <>{formatDate(getValue() as Date, 'dd MMM yyyy')}</>
          ) : (
            '-'
          );
        },
      },
      {
        header: t(`common:invoice_number`),
        accessorKey: 'invoiceNo',
        minSize: 100,
      },
      {
        header: t('common:type'),
        accessorKey: 'type',
        minSize: 100,
        cell: ({ getValue }) => <>{capitalize(getValue() as string)}</>,
      },
      {
        header: t('common:description'),
        accessorKey: 'description',
        minSize: 300,
      },
    ],
    [formatDate, t],
  );

  return (
    <CardContainer>
      <Text variant="HeadingXSmall">{t('common:latest_transactions')}</Text>
      <Separator gap={16} />
      <TableComponent
        columns={columns}
        isLoading={isLoading}
        data={data || []}
      />
    </CardContainer>
  );
}
